import { render, staticRenderFns } from "./Bhomepage.vue?vue&type=template&id=3ea35896&scoped=true&"
import script from "./Bhomepage.vue?vue&type=script&lang=js&"
export * from "./Bhomepage.vue?vue&type=script&lang=js&"
import style0 from "./Bhomepage.vue?vue&type=style&index=0&id=3ea35896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea35896",
  null
  
)

export default component.exports